import { Component, OnInit } from '@angular/core';
import { Cotizacion, TipoCotizacion, EstadoCotizacion } from '../../../../interfaces/cotizacion';
import { ActivatedRoute } from '@angular/router';
import { CotizacionService } from '../../../../providers/cotizacion.service';
import { MatSnackBar, MatDialog } from '@angular/material';
import { Entidad, TipoEntidad } from '../../../../interfaces/entidad';
import { Accesorio } from '../../../../interfaces/accesorio';
import { Producto } from '../../../../interfaces/producto';
import { Item } from '../../../../interfaces/item';
import { Contacto, TipoContacto } from '../../../../interfaces/contacto';
import { ContactoService } from '../../../../providers/contacto.service';
import { ProductoService } from '../../../../providers/producto.service';
import { Imagen } from '../../../../interfaces/imagen';
import { TipoGarantia } from '../../../../interfaces/tipo-garantia';
import { EmailCotizacionDialog } from '../../../../forms/cotizaciones/email-cotizacion-dialog/email-cotizacion-dialog.component';
import { Globals } from '../../../../globals';
import { AuthenticationService } from '../../../../providers/auth.service';
import { TipoMoneda } from '../../../../interfaces/tipo-moneda';
import { TipoPago } from '../../../../interfaces/tipo-pago';
import { TipoValidez } from '../../../../interfaces/tipo-validez';
import { TipoPlazo } from '../../../../interfaces/tipo-plazo';
import { TipoProducto } from '../../../../interfaces/tipo-producto';
import { ZerosPipe } from '../../../../pipes/transforms/zeros.pipe';
import { Telefono } from '../../../../components/telefono/telefono.component';
import { TipoEntrega } from '../../../../interfaces/tipo-entrega';
import { Competidor } from '../../../../interfaces/competidor';
import { FormatDatePipe } from '../../../../pipes/transforms/format-date.pipe';
import { Usuario } from '../../../../interfaces/usuario';
import { TipoCondicion } from '../../../../interfaces/tipo-condicion';
import { GeneralService } from '../../../../providers/general.service';

@Component({
  selector: 'app-imprimir-cotizacion-pagina',
  templateUrl: './imprimir-cotizacion-pagina.component.html',
  styleUrls: ['./imprimir-cotizacion-pagina.component.scss']
})
export class ImprimirCotizacionPaginaComponent implements OnInit {
  ahora = new Date();
  referenciaTexto: string;
  itemIndex: number = 0;
  mostrarFirma: boolean = true;
  mostrarCondicionesComerciales: boolean = true;
  mostrarPlazosEntrega: boolean = true;
  contactoSeleccionado: Contacto;
  IdCotizacion?: number | string;
  cotizacion: Cotizacion;
  contactos: Contacto[] = <Contacto[]>[];
  fechaImpresion: Date = null;
  cargandoCotizacion: boolean = false;
  cargandoItems: boolean = false;
  cargandoContactos: boolean = false;
  cargandoImagenes: boolean = false;
  cotizacionArchivos: string[];
  showFooter: boolean = true;
  // IMAGENES
  img_header$: any = null;
  img_firma$: any = null;
  img_footer$: any = null;
  descargandoPdf: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private cotizacionService: CotizacionService,
    private contactoService: ContactoService,
    private productoService: ProductoService,
    public authService: AuthenticationService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    public globals: Globals,
    private zerosPipe: ZerosPipe,
    private formatDate: FormatDatePipe,
    public general: GeneralService
  ) { }

  ngOnInit() {
    this.cotizacion = new Cotizacion();

    // crear un cotizacion con el ID buscado
    this.route.params.subscribe(params => {
      this.IdCotizacion = params['id'];
    });

    this.traerDatosCotizacion();

    // this.img_header$ = this.getBase64('assets/impresion/cotizacion/' + this.globals.empresa + '/logo.' + this.globals.impresion_header_extension);
    // this.img_firma$ = this.getBase64('assets/impresion/cotizacion/' + this.globals.empresa + '/firma.' + this.globals.impresion_firma_extension);
    // this.img_footer$ = this.getBase64('assets/impresion/cotizacion/' + this.globals.empresa + '/footer.' + this.globals.impresion_footer_extension);
    this.img_header$ = this.general.logo_impresion;
    this.img_firma$ = this.general.firma_impresion;
    this.img_footer$ = this.general.footer_impresion;

  }

  traerDatosCotizacion(): void { // traer datos del cotizacion para mostrarlos
    this.cargandoCotizacion = true;
    this.cotizacionService.getCotizaciones(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'fechaAlta',
        order: 'asc'
      },
      {
        IdCotizacion: this.IdCotizacion
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data) {
          var cotizacion = respuesta.data.cotizaciones[0];
          if (cotizacion) {
            respuesta.data.cotizaciones.forEach(cotizacion => {
              this.cotizacion = this.cotizacion = new Cotizacion(
                cotizacion.IdCotizacion,
                cotizacion.fechaAlta,
                <Entidad>{
                  IdEntidad: cotizacion.entidad.id,
                  razonSocial: cotizacion.entidad.razonSocial,
                  tipoEntidad: <TipoEntidad>{
                    IdTipo: cotizacion.entidad.tipo.IdTipo,
                    descripcion: cotizacion.entidad.tipo.TipoDescripcion
                  }
                },
                <TipoCotizacion>{
                  IdTipo: cotizacion.tipo.id,
                  descripcion: cotizacion.tipo.descripcion
                },
                cotizacion.detalle,
                <Item[]>[],
                new TipoEntrega(
                  cotizacion.tipoEntrega.id,
                  cotizacion.tipoEntrega.descripcion
                ),
                <EstadoCotizacion>{
                  IdEstado: cotizacion.estado.id,
                  descripcion: cotizacion.estado.descripcion
                },
                cotizacion.total,
                <TipoGarantia>{
                  id: cotizacion.garantia.id,
                  descripcion: cotizacion.garantia.descripcion
                },
                Object.assign([], cotizacion.condiciones),
                cotizacion.obra,
                cotizacion.fechaVencimiento,
                cotizacion.horaVencimiento ? cotizacion.horaVencimiento : null,
                cotizacion.estadoMotivo,
                cotizacion.destinoEntrega,
                new TipoMoneda(
                  cotizacion.moneda.id,
                  cotizacion.moneda.descripcion,
                  cotizacion.moneda.subfijo
                ),
                new TipoPago(
                  cotizacion.pago.id,
                  cotizacion.pago.descripcion
                ),
                new TipoValidez(
                  cotizacion.validez.id,
                  cotizacion.validez.descripcion
                ),
                Object.assign([], cotizacion.tipoImpuesto),
                cotizacion.fechaApertura,
                !!+cotizacion.editable,
                cotizacion.created_by,
                cotizacion.numero,
                cotizacion.fechaHoraModificacion,
                new Competidor(
                  cotizacion.competidor.id,
                  cotizacion.competidor.descripcion
                ),
                cotizacion.vecesModificada,
                new Usuario(
                  cotizacion.responsable.IdUsuario,
                  cotizacion.responsable.usuario,
                  null,
                  null,
                  null,
                  cotizacion.responsable.nombre,
                  cotizacion.responsable.apellido
                ),
                !!+cotizacion.alMenosUnArchivo
              );
            });

            this.traerItems(+this.cotizacion.IdCotizacion); // traer sus items
            this.traerContactos(+this.cotizacion.entidad.IdEntidad); // traer los contactos del prospecto
            this.traerArchivosCotizacion(+this.cotizacion.IdCotizacion);

            // reset variables de la impresión
            this.mostrarCondicionesComerciales = true;
            this.mostrarPlazosEntrega = true;
            this.fechaImpresion = new Date();
            this.referenciaTexto = "Señores/as";
            this.mostrarFirma = true;
          } else {
            this.snackBar.open('No se encontraron los datos buscados', 'OK', { duration: 2750 });
          }
        }
      },
      () => {
        this.cargandoCotizacion = false;
      },
      () => {
        this.cargandoCotizacion = false;
      }
    );
  }

  traerItems(IdCotizacion: number): void {
    if (IdCotizacion) { // si hay un ID
      this.cargandoItems = true
      this.cotizacion.items = [];
      this.cotizacionService.getCotizacionItems(
        {
          page: null,
          pageSize: null
        },
        {
          sort: 'fechaAlta',
          order: 'asc'
        },
        {
          IdCotizacion: IdCotizacion
        }
      ).subscribe(
        respuesta => {
          if (respuesta.estado == 1 && respuesta.data && respuesta.data.items) {
            var index: number = 1;
            respuesta.data.items.forEach((item) => {
              this.cotizacion.items.push(
                Object.assign(
                  new Item(
                    item.IdItem,
                    <Producto>{
                      IdProducto: item.producto.id,
                      descripcion: item.producto.descripcion,
                      caracteristicas: item.producto.caracteristicas,
                      tipo: <TipoProducto>{
                        descripcion: item.producto.tipo.descripcion
                      }
                    },
                    item.cantidad,
                    item.precioUnitario,
                    item.label,
                    item.customDescripcion,
                    <Accesorio[]>[],
                    !!+item.especial,
                    !!+item.productoPrecioIncluido,
                    new TipoPlazo(
                      item.plazo.id,
                      item.plazo.descripcion
                    )
                  ),
                  {
                    index: index++
                  }
                ));

              var indexLastItem = this.cotizacion.items.length - 1;
              this.traerImagenesProducto(this.cotizacion.items[indexLastItem]);

              item.accesorios.forEach(accesorio => {
                this.cotizacion.items[indexLastItem].accesorios.push(
                  Object.assign(
                    <Accesorio>{
                      IdAccesorio: accesorio.id,
                      descripcion: accesorio.descripcion,
                      importeAsignado: accesorio.importeAsignado,
                      precioIncluido: !!+accesorio.precioIncluido,
                      precioDescripcion: accesorio.precioDescripcion,
                      cantidad: accesorio.cantidad
                    },
                    {
                      index: index++
                    }
                  ));
              });
            });
          }

          this.cargandoItems = false;
        },
        () => {
          this.cargandoItems = false;
        }
      );
    }
  }

  traerArchivosCotizacion(IdCotizacion: number): void {
    if (IdCotizacion) {
      this.cotizacionArchivos = [];
      this.cotizacionService.getArchivosCotizacion(
        {
          page: null,
          pageSize: null
        },
        {
          sort: 'orden',
          order: 'asc'
        },
        {
          IdCotizacion: IdCotizacion
        }
      ).subscribe(
        respuesta => {
          if (respuesta.estado == 1 && respuesta.data && respuesta.data.archivos) {
            respuesta.data.archivos.forEach(archivo => {
              this.cotizacionArchivos.push(archivo.nombreWeb);
            });
          }
        },
        () => {

        }
      );
    }
  }

  traerContactos(IdEntidad: number): void {
    if (IdEntidad) { // si hay un ID
      this.cargandoContactos = true
      this.contactos = <Contacto[]>[];
      this.contactoService.getContactos(
        {
          page: null,
          pageSize: 50
        },
        {
          sort: 'nombre',
          order: 'asc'
        },
        {
          IdEntidad: IdEntidad
        }
      ).subscribe(
        respuesta => {
          if (respuesta.estado == 1 && respuesta.data && respuesta.data.contactos) {
            respuesta.data.contactos.forEach(contacto => {
              this.contactos.push(<Contacto>{
                celularCodigoPais: contacto.celularCodigoPais,
                celularCodigoArea: contacto.celularCodigoArea,
                celularNumero: contacto.celularNumero,
                email: contacto.email,
                nombre: contacto.nombre,
                telefonoCodigoPais: contacto.telefonoCodigoPais,
                telefonoCodigoArea: contacto.telefonoCodigoArea,
                telefonoNumero: contacto.telefonoNumero,
                tipoContacto: <TipoContacto>{
                  IdTipoContacto: contacto.tipo.id,
                  tipoContactoDesc: contacto.tipo.desc
                },
                idContacto: contacto.idContacto,
                interno: contacto.interno
              });
            });

            // ordenar contactos por nombre
            this.contactos.sort((a, b) => {
              if (a.nombre < b.nombre)
                return -1;
              if (a.nombre > b.nombre)
                return 1;
              return 0;
            });

            if (this.contactos[0]) {
              this.contactoSeleccionado = this.contactos[0];
            }
          }

          this.cargandoContactos = false;
        },
        () => {
          this.cargandoContactos = false;
        }
      );
    }
  }

  traerImagenesProducto(item: Item): void {
    if (item.producto.IdProducto) {
      this.cargandoImagenes = true;
      this.productoService.getImagenesProducto(
        {
          page: null,
          pageSize: null
        },
        {
          sort: 'fechaAlta',
          order: 'asc'
        },
        {
          IdProducto: item.producto.IdProducto
        }
      ).subscribe(
        respuesta => {
          if (respuesta && respuesta.estado == 1 && respuesta.data && respuesta.data.fotos) {
            respuesta.data.fotos.forEach(foto => {
              if (!!+foto.destacada) {
                item.setImagenDestacada(new Imagen(
                  foto.id,
                  foto.link,
                  foto.orden,
                  foto.destacada
                ));
              }
            });
          }

          this.cargandoImagenes = false;
        },
        () => {
          this.cargandoImagenes = false;
        }
      );
    }
  }

  getCotizacionHTML(): string {
    let printContents = document.getElementById('seccion-para-imprimir').innerHTML;

    return `
      <html>
        <head>
          <meta charset="UTF-8">
		      <meta name="keywords" content="HTML,CSS">
		      <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>` + this.general.nombre_empresa + `</title>
          <style>
            table {
              height: 100%;
              width: 100%;
            }
            .no-imprimir {
              display: none !important;
            }
            @media print {
              body {
                -webkit-print-color-adjust: exact;
              }
            }
            #img-footer {
              position: fixed;
              bottom: 0;
              left: 0;
              right: 0;
            }
            /* ************************************** */
            /*  SECTOR DONDE SE PEGA EL CSS EDITABLE  */
            /* ************************************** */
            table {
              border-collapse: collapse;
              font-family: sans-serif !important;
              font-size: 16px !important;
              color: rgba(0, 0, 0, 0.87) !important;
            }
            .tabla-item-th {
              padding: 0px 8px;
              border: 1px solid #827d7d;
              text-align: center;
            }
            .tabla-item-td {
              border: 1px solid #b8b8b8;
              padding: 4px;
              text-align: center;
            }
            .impresion-sector {
              font-family: 'Lucida Sans Unicode', 'Lucida Grande', sans-serif;
            }
            .tr-item {
              height: 38px;
              border-bottom: 2px solid #9a9a9a;
            }
          </style>
        </head>
        <body onload="window.print(); window.close();">
          ${printContents}
        </body>
      </html>`;
  }

  imprimir(): void {
    var popupHeight = window.innerHeight - 80;
    var popupWidth = window.innerHeight - 80;
    var popupTop = window.innerHeight / 2 - popupHeight / 2;
    var popupLeft = window.innerWidth / 2 - popupWidth / 2;

    var popupWin = window.open('', '_blank', 'top=' + popupTop + ', left=' + popupLeft + ', width=' + popupWidth + 'px, height=' + popupHeight + 'px');
    popupWin.document.open();
    popupWin.document.write(this.getCotizacionHTML());
    popupWin.document.close();
  }

  openDialogEmail(): void {
    // leer cuerpo del email sin el footer
    this.showFooter = false;
    setTimeout(() => {
      let pdf = this.getCotizacionHTML();
      this.showFooter = true;
      setTimeout(() => {
        // mpdf necesita el footer por separado
        let footer = document.getElementById('img-footer').outerHTML;
        this.dialog.open(EmailCotizacionDialog, {
          disableClose: true,
          data: {
            pdf: pdf,
            footer: footer,
            contactos: Object.assign([], this.contactos),
            IdCotizacion: this.IdCotizacion,
            IdFormateado: this.formatDate.transform(this.cotizacion.fechaAlta, "YYYY-MM-DD", "YY") + '/' + this.zerosPipe.transform(this.cotizacion.numero, 7)
          },
          minWidth: '600px'
        });
      }, 0);
    }, 0);
  }

  descargarPdf() {
    this.descargandoPdf = true;
    // leer cuerpo del email sin el footer
    this.showFooter = false;
    setTimeout(() => {
      let pdf = this.getCotizacionHTML();
      this.showFooter = true;
      setTimeout(() => {
        // mpdf necesita el footer por separado
        let footer = document.getElementById('img-footer').outerHTML;

        this.cotizacionService.descargarPdfCotizacion(
          pdf,
          footer,
          <string>this.IdCotizacion,
          this.formatDate.transform(this.cotizacion.fechaAlta, "YYYY-MM-DD", "YY") + '/' + this.zerosPipe.transform(this.cotizacion.numero, 7)
        ).subscribe(
          respuesta => {
            if (respuesta && respuesta.estado == 1 && respuesta.link) {
              let downloadLink = document.createElement("a");
              downloadLink.target = '_blank';
              downloadLink.href = respuesta.link;
              document.body.appendChild(downloadLink);
              downloadLink.click();
              document.body.removeChild(downloadLink);
            } else {
              this.snackBar.open('No se pudo generar el archivo pdf', 'OK', { duration: 4750 });
            }

            this.descargandoPdf = false;
          },
          () => {
            this.descargandoPdf = false;
          }
        )
      }, 0);
    }, 0);
  }

  /**
   * Quitar un dato de la cotizacion para no imprimirlo
   * @param stringKeys
   */
  quitarDato(stringKeys: string) {
    let keys = stringKeys.split('.');

    switch (keys.length) {
      case 1:
        this.cotizacion[keys[0]] = null;
        break;
      case 2:
        this.cotizacion[keys[0]][keys[1]] = null;
        break;
      case 3:
        this.cotizacion[keys[0]][keys[1]][keys[2]] = null;
        break;
    }
  }

  /**
   * Quitar una condicion comercial de la cotizacion para no improimirla
   * @param condicionComercial
   */
  quitarCondicionComercial(condicionComercial: TipoCondicion): void {
    if (this.cotizacion.condiciones) {
      this.cotizacion.condiciones.forEach((condicionItem: TipoCondicion, index: number) => {
        if (condicionItem.id == condicionComercial.id) {
          this.cotizacion.condiciones.splice(index, 1);
          return;
        }
      });
    }
  }

  /**
   * Quitar un contacto de la impresión
   * @param contacto contacto para quitar de la impresión
   */
  quitarContacto(contacto: Contacto): void {
    this.contactos = this.contactos.filter((contactoItem: Contacto) => contactoItem.idContacto != contacto.idContacto);
  }

  colorHexToRGB(hex): string {
    let cutedHash = (hex.charAt(0) == "#") ? hex.substring(1, 7) : hex;

    return this.hexToR(cutedHash) + ',' + this.hexToG(cutedHash) + ',' + this.hexToB(cutedHash);
  }

  hexToR(h): number {
    return parseInt(h.substring(0, 2), 16);
  }

  hexToG(h): number {
    return parseInt(h.substring(2, 4), 16);
  }

  hexToB(h): number {
    return parseInt(h.substring(4, 6), 16);
  }

  getBase64(url: string) {
    return new Promise((resolve, reject) => {
      let xhr: XMLHttpRequest = new XMLHttpRequest();
      xhr.onload = function () {
        let reader: FileReader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result);
        }
        reader.readAsDataURL(xhr.response);
      };
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
    });
  }
}
